import { MemberImportWizard } from '@/components/members/member-import-wizard'

export function AdminMembersImport() {
  return <MemberImportWizard />
}
